import { useEffect, useState, useCallback } from 'react';

const DELAY_MS = 30_000;
const COOLDOWN_MS = 2 * 60 * 60 * 1000; // 2 hours
const STORAGE_KEY = 'insight_consultation_prompt_dismissed_at';

function isWithinCooldown(): boolean {
  if (typeof window === 'undefined') return true;

  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return false;

    const dismissedAt = Number(raw);
    if (!Number.isFinite(dismissedAt)) return false;

    return Date.now() - dismissedAt < COOLDOWN_MS;
  } catch {
    return false;
  }
}

function markDismissed(): void {
  try {
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
  } catch {
    // ignore storage errors (private mode, quota, etc.)
  }
}

export const useConsultationPrompt = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (isWithinCooldown()) return;

    const timeoutId = window.setTimeout(() => {
      setIsOpen(true);
    }, DELAY_MS);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, []);

  const onClose = useCallback(() => {
    markDismissed();
    setIsOpen(false);
  }, []);

  return { isOpen, onClose };
};
